import React from 'react'

const AcceptedOrderDeliveryPeykContainer = () => {
  return (
    <div>AcceptedOrderDeliveryPeykContainer</div>
  )
}

export default AcceptedOrderDeliveryPeykContainer